import { render, staticRenderFns } from "./tenantOne.vue?vue&type=template&id=b786ab08"
import script from "./tenantOne.vue?vue&type=script&lang=js"
export * from "./tenantOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports